
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/editorial",
      function () {
        return require("private-next-pages/editorial/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/editorial"])
      });
    }
  